import { PriceValue } from '@b2b/types/core';
import { PersonTypeVo, SalesChannelEntryVo } from '@b2b/types/event';
import { OrderEventItems } from '@b2b/types/order';
import { DiscountType } from '@b2b/types/order/api/enums';
import { CouponVo } from '@b2b/types/order/api/will-call-order-detail.type';

// Re-export pure types from utils
export type { EmailLanguage, ProcessedOrderEvent } from '../utils/order-processing.utils';
export type { DiscountMeta } from '../utils/order-validation.utils';
export { pickDiscountMeta } from '../utils/order-validation.utils';

export const EmailOptions = {
  None: '0', // noEmail = true, sendEmailToAll = false
  PrimaryOnly: '1', // noEmail = false, sendEmailToAll = false
  AllRecipients: '2', // noEmail = false, sendEmailToAll = true
} as const;

export type EmailOption = (typeof EmailOptions)[keyof typeof EmailOptions];

export type PersonTypeKey = `item-${string}-${string}` | `item-${string}-${string}-${string}`;

export interface SelectedItemType {
  discountedPrice: PriceValue;
  discountedUnitPrice: PriceValue;
  itemType: 'Event';
  itemTypeName: string;
  name: string;
  price: PriceValue;
  quantity: number;
  /**
   * The quantity of tickets that were already on the original order
   */
  resolvedQuantity: number;
  itemAddedToOrder: boolean;
  ticketTypeId: string; // Legacy field for API compatibility
  ticketTypeName: string; // Legacy field for API compatibility
  ticketingTypeDescription: string;
  ticketingTypeName: string;
  unitPrice: PriceValue;
  personType: PersonTypeVo;
  salesChannels: SalesChannelEntryVo[];
  discountId?: string;
  discountName?: string;
  discountType?: DiscountType;
  discountValue?: PriceValue;
  couponDetail?: CouponVo;
}


export const DEFAULT_EMAIL_LANGUAGE_CODE = 'en-us';

/**
 * Extended OrderEventItems with additional UI state properties
 * added during order processing for display purposes.
 * Extends ProcessedOrderEvent with CSR toggle properties.
 */
export interface ProcessedOrderEventItems extends OrderEventItems {
  toggleCSRPrices: boolean;
  toggleCSRAddons: boolean;
  startDate: string;
  startHour: string;
  isCancelled: boolean;
  isSuspended: boolean;
  formattedCancellationDate: string;
}

